module.exports = __webpack_public_path__ + "static/media/CompensationSurvey_VideoScript_v2_1643903412037.53f80235.docx";